import { render } from "./ProductSignatureField.vue?vue&type=template&id=f65ac120"
import script from "./ProductSignatureField.vue?vue&type=script&lang=js"
export * from "./ProductSignatureField.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__